import { Timestamp } from "@angular/fire/firestore";

export interface CryptoWallet {
    provider: "metamask_extension" | "metamask_wc" | "metamask_sdk" | 'phantom' | null;
    chainId: string | null;
    address: string | null;
    chain: ChainType | null;
    session: string | null;
    connectedAt: Timestamp | null;
}

export interface CryptoWalletWithoutNull {
    provider: "metamask_extension" | "metamask_wc" | "metamask_sdk" | 'phantom';
    chainId: string;
    address: string;
    chain: ChainType;
    session: string | null; // metamask does not have
    connectedAt: Timestamp;
}

export enum CachingStatus {
    CACHING = 'CACHING',
    CACHED = 'CACHED',
    NOT_CACHED = 'NOT_CACHED',
    CACHING_FAILED = 'CACHING_FAILED',
    CACHING_IN_WAITING = 'CACHING_IN_WAITING'
}

export interface CryptoState extends CryptoWallet {
    nftAssets: NftAsset[];
    collections: Collection[];
    searchText: string;
    favorites: NftAsset[];
    loadingStatus: CachingStatus;
}

export const CRYPTO_INIT_STATE: CryptoState = {
    provider: null,
    chainId: null,
    chain: null,
    session: null,
    address: null,
    connectedAt: null,
    nftAssets: [],
    loadingStatus: CachingStatus.NOT_CACHED,
    collections: [],
    searchText: '',
    favorites: []
}

export interface NftAsset {
    name: string;
    collectionTokenId: string;
    collectionName: string;
    imageUrl: string;
    collectionAddress: string;
    traits: Trait[];
    usingCroppedImage?: boolean;
    croppedImageUrl?: string;
    type: string
}

export interface Collection {
    name: string;
    imageUrl: string;
    bannerImageUrl: string;
    description: string;
    address: string;
}

export interface TokenMetadata {
    name: string;
    image?: string;
    image_url?: string;
    description: string;
    attributes: Trait[];
}

export interface Trait {
    trait_type: string,
    value: string
}

interface BaseToken {
    collectionAddress: string;
    tokenId: string;
    owner: string;
    croppedImageUrl?: string;
    type: string;
}

export interface HealthyToken extends BaseToken {
    isHealthy: true;
    tokenUri: string;
    metadata: TokenMetadata;
    imageUrl: string;
    name: string;
}

export interface CorruptedToken extends BaseToken {
    isHealthy: false;
    name?: string;
    tokenUri?: string;
    metadata?: TokenMetadata;
    imageUrl?: string;
}

export type Token = HealthyToken | CorruptedToken;

export type ChainType = "ethereum" | "solana";
